export const AdGroupAdCustomizerAttribute = {
  parent: 'AdGroup',
  properties: {
    'bulk-upload-type': {
      type: 'string',
      value: 'AdGroup AdCustomizer Attribute',
    },
    AdCustomizerAttributeValue: {
      'bulk-upload-header': 'AdCustomizer AttributeValue',
    },
  },
};
